const ensureTrailingSlash = (url) => (url.endsWith("/") ? url : `${url}/`)

export const API_DOMG = ensureTrailingSlash(
  process.env.REACT_APP_API_DOMG || "https://localhost:5445/"
)

export const API_DOMG_NODE = ensureTrailingSlash(
  process.env.REACT_APP_API_DOMG_NODE || "http://localhost:3001/api/v1/"
)
